import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import Dashboard from '@/components/Dashboard'
import GroupForm from '@/components/Groups/GroupForm/GroupForm'

import GroupSettingHeader from '../settings/group-settings-header'

export const GroupsFormPage = () => {
  const { t } = useTranslation(['groups'])
  const { groupId } = useParams()
  return (
    <Dashboard.Container className={`ctp-groups`}>
      <GroupSettingHeader
        isFormPage
        title={groupId ? t('groups:form.editTitle') : t('groups:form.createTitle')}
      />
      <div className="ctp-groups__inner">
        <GroupForm />
      </div>
    </Dashboard.Container>
  )
}
